import React from "react";
import './style.css'

function BotaoBranco({texto, onClick}) {
    return (
        <button className="botao-branco" onClick={onClick}>{texto}</button>
    )
}

export default BotaoBranco